import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { fetchMicrocopy, fetchSections } from './contentful-api.mjs';
import { escapeHtml } from './shared.mjs';
export { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

const textOf = (node) =>
  escapeHtml((node.content || []).map((c) => c.value || '').join(''));

const fileOf = (node) =>
  node.data && node.data.target && node.data.target.fields
    ? node.data.target.fields.file
    : null;

// Link targets can be unpublished or deleted, in which case the API leaves
// them out of `includes` and the default renderers throw. These fall back to
// the visible text instead.
const renderNode = {
  [INLINES.ASSET_HYPERLINK]: (node) => {
    const file = fileOf(node);
    return file
      ? `<a href="${escapeHtml(file.url)}">${textOf(node)}</a>`
      : textOf(node);
  },
  [INLINES.ENTRY_HYPERLINK]: (node) => textOf(node),
  [INLINES.EMBEDDED_ENTRY]: () => '',
  [BLOCKS.EMBEDDED_ENTRY]: () => '',
  [BLOCKS.EMBEDDED_ASSET]: (node) => {
    const file = fileOf(node);
    if (!file || !/^image\//.test(file.contentType || '')) return '';
    const title = escapeHtml(node.data.target.fields.title || '');
    return `<img src="${escapeHtml(file.url)}" alt="${title}" loading="lazy">`;
  },
};

export const parseRichText = (value) => {
  if (!value) return '';
  return documentToHtmlString(value, { renderNode });
};

const cache = {
  microcopy: null,
  sections: null,
};

export default ({ locale }, options = {}) => {
  if (cache.microcopy && cache.sections) {
    return Promise.resolve({ ...cache, locale });
  }
  return Promise.all([
    fetchMicrocopy(locale.code, options),
    fetchSections(locale.code),
  ]).then(([microcopy, sections]) => {
    cache.microcopy = microcopy;
    cache.sections = sections;
    return { microcopy, sections, locale };
  });
};

export const fetchMicrocopyOnly = (locale) => fetchMicrocopy(locale.code);
